export default "__VITE_ASSET__2f2fff0d__"